export default __webpack_public_path__ + "static/media/(2)Frutilla.ee1cb567.jpg";